import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue, removeFields, setNewForm, updateFields, updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_GA_LIBRE_SAVE_BANK } from 'apps/auth/constants/UrlConstants';
import { timer } from 'apps/auth/helpers/utils';
import { useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';

import { HAVE_BANK_ACCOUNT } from './LibreHistoryScreenConstants';

const FORM_NAME = 'searchLibreBank';

const ChoosingUserBank = (props) => {
    const submitRef = useRef(null);
    const submitPayRef = useRef(null);
    const timerId = useRef(null);

    useEffect(() => {
        return () => clearTimeout(timerId.current);
    }, []);

    const fields = useFields(FORM_NAME);
    const { banks } = useExtra();
    const messages = usePageMessages();

    useEffect(() => {
        if (!fields?.search) {
            const search = getField('search', '', null, false, false, messages.searchPlaceholder, 'search');
            props.setNewForm(FORM_NAME, { [search.name]: search });
        }

        const bankId = getField('bankId', '', null, false, false, '', 'text', true, true);
        props.updateFields(FORM_NAME, { [bankId.name]: bankId });
    }, []);

    const onSubmitHandler = () => {
        props.startTimerAfterSubmit();
    };

    const getBankLogo = (logo) => {
        if (logo) {
            return <DiskBadge variant="hasBorderedImg" src={`data:image/png;base64, ${logo}`} alt="" />;
        }

        return <DiskBadge variant="tertiary" iconName="bank" />;
    };

    const clickBankNotTheList = () => {
        Promise.all([props.changeFormFieldValue(FORM_NAME, 'other', 'bankId')])
            .then(() => props.updateFormProperties(FORM_NAME, null, false))
            .then(() => {
                submitPayRef.current.click();
            })
            .finally(() => {
                props.removeFields(FORM_NAME, ['bankId']).then(() => props.updateFormProperties(FORM_NAME, null, true));
            });
    };

    const getBankItem = (bank) => (
        <Panel
            type="button"
            isHoverable
            negativeMargin
            key={bank.bankId}
            onClick={() => {
                Promise.all([props.changeFormFieldValue(FORM_NAME, bank.bankId, 'bankId')])
                    .then(() => props.updateFormProperties(FORM_NAME, null, false))
                    .then(() => {
                        submitPayRef.current.click();
                    });
            }}
        >
            <DiskBadgeWrapper>{getBankLogo(bank.logo)}</DiskBadgeWrapper>
            {bank.bankName}
        </Panel>
    );

    const changeHandler = () => {
        timer(
            timerId.current,
            () => {
                submitRef.current.click();
            },
            1000,
        );
    };

    const getListOfBanks = () => {
        if (fields?.search?.value) {
            return <>{banks.map((bank) => getBankItem(bank))}</>;
        } else {
            return (
                <>
                    <Row indent="adaptive-32-48">
                        <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                            {messages.popularTitle}
                        </Text>
                        {banks.filter((f) => f?.isPopular).map((bank) => getBankItem(bank))}
                    </Row>
                    <Text variant="div" color="secondary" size="subheader" indent="adaptive-32-48">
                        {messages.otherTitle}
                    </Text>
                    {banks.filter((f) => !f?.isPopular).map((bank) => getBankItem(bank))}
                </>
            );
        }
    };

    return (
        <ModalComponent
            isIconClose
            canCloseModal
            onCloseIconClick={(e) => {
                e.preventDefault();
                props.setScreen(HAVE_BANK_ACCOUNT);
            }}
        >
            <HeaderPanel title={messages.selectBankTitle} />
            {fields?.search && (
                <Row indent="adaptive-32-48">
                    <Form action={`/auth/ga/libre/search/bank/info`} formName={FORM_NAME}>
                        <InputText formName={FORM_NAME} field={fields.search} onChangeHandler={changeHandler} isNewInput />
                        <Button type="submit" variant={'hidden'} ref={submitRef} />
                    </Form>
                </Row>
            )}
            {banks && getListOfBanks()}
            <Panel
                type="button"
                onClick={() => {
                    clickBankNotTheList();
                }}
                isHoverable
                negativeMargin
            >
                <DiskBadgeWrapper>
                    <DiskBadge variant="secondary" iconName="bank" />
                </DiskBadgeWrapper>
                <Text color="primary">{messages.bankNotInList}</Text>
            </Panel>
            <Form formName={FORM_NAME} action={AUTH_GA_LIBRE_SAVE_BANK} onSubmitHandler={onSubmitHandler} validateForm={false} getCanonicalPath={true}>
                <Button type="submit" variant={'hidden'} ref={submitPayRef} />
            </Form>
        </ModalComponent>
    );
};

export default connect(null, {
    setNewForm,
    changeFormFieldValue,
    updateFormProperties,
    updateFields,
    removeFields,
})(ChoosingUserBank);
